import { useState } from "react";
import { Star, X } from "lucide-react";
import { toast } from "sonner";
import Btn from "./Btn";
import api, { apiErr } from "../lib/api";

export default function RatingPrompt({ onClose }) {
  const [stars, setStars] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!stars) { toast.error("Pilih jumlah bintang dulu"); return; }
    setBusy(true);
    try {
      await api.post("/ratings", { stars, comment });
      toast.success("Terima kasih atas ulasanmu! ⭐");
      localStorage.setItem("su-rated", "1");
      onClose();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  const dismiss = () => { localStorage.setItem("su-rated-dismiss", String(Date.now())); onClose(); };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={dismiss} />
      <div className="relative w-full max-w-sm card-chunky p-6 text-center animate-pop" data-testid="rating-prompt">
        <button data-testid="rating-dismiss" onClick={dismiss} className="absolute top-3 right-3 w-8 h-8 rounded-lg grid place-items-center border border-su-border hover:border-su-primary"><X className="w-4 h-4" /></button>
        <h2 className="font-heading font-bold text-2xl mb-1">Suka dengan SkorUp?</h2>
        <p className="text-su-muted text-sm mb-4">Beri rating & ceritakan pengalamanmu!</p>
        <div className="flex justify-center gap-1 mb-4">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} data-testid={`star-${n}`} onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)} onClick={() => setStars(n)}
              className="transition-transform hover:scale-125">
              <Star className={`w-9 h-9 ${(hover || stars) >= n ? "text-su-energy fill-su-energy" : "text-su-muted"}`} />
            </button>
          ))}
        </div>
        <textarea data-testid="rating-comment" value={comment} onChange={(e) => setComment(e.target.value)} rows={3}
          placeholder="Komentar (opsional)" maxLength={500}
          className="w-full px-3 py-2 rounded-xl border border-su-border bg-su-bg text-sm outline-none focus:border-su-primary mb-4 resize-none" />
        <Btn data-testid="rating-submit" onClick={submit} disabled={busy} className="w-full">{busy ? "Mengirim..." : "Kirim Ulasan"}</Btn>
      </div>
    </div>
  );
}
